import { type FunctionComponent, useEffect } from 'react';

import { GtagLogger } from '../logger/GtagLogger';
import { useConfigSlice } from '../store/slices/config/selectors';
import { useSettingsSlice } from '../store/slices/settings/selectors';

import { Telemetry } from './Telemetry';

export const TelemetryConnector: FunctionComponent = () => {
  const playerConfig = useConfigSlice.playerConfig();
  const currentLanguage = useSettingsSlice.currentLanguage();

  useEffect(() => {
    if (playerConfig) {
      GtagLogger.updateUserId(playerConfig.userId);

      Telemetry.updateMeta({
        location: playerConfig.countryCode,
        userId: playerConfig.userId,
      });
    }
  }, [playerConfig]);

  useEffect(() => {
    if (currentLanguage) {
      Telemetry.updateMeta({
        language: currentLanguage,
      });
    }
  }, [currentLanguage]);

  return null;
};
